import request from "../utils/request.js";
import axios from 'axios';
import qs from 'qs';
export function getFeedbackManagementList(queryParams) {
  return request({
    url: `/feedbackManagement/list`,
    method: 'GET',
    params: queryParams,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
  });
}
export function sendEmail(data) {
  return request({
    url: `/feedbackManagement/email`,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    data: data
  });
}
export const getSignedUrl = data => {
  return request(`/feedbackManagement/signed-url/screenshot`, {
    method: 'POST',
    data:data,
  });
};
export const uploadToS3 = async (signedUrl, file, onUploadProgress, cancelToken) => {
  return axios.put(signedUrl, file, {
    cancelToken,
    onUploadProgress,
    headers: {
      'Content-Type': file.type,
    },
  });
};